import {
  Component,
  OnInit,
  NgZone,
  ElementRef,
  Inject,
  ViewChildren,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { LoginService } from '../home/login.service';
import { FormBuilder, Validators } from '@angular/forms';
import { AppComponent } from '../app.component';
import { OnlineOrderService } from '../onlineorder/onlineorder.service';
import { IAccount } from '../account/account';
import { ToastrService } from 'ngx-toastr';
import { ICartItems } from '../onlineorder/cartitems';
import { OrderService } from '../onlineorder/order.service';
import { IRep } from '../home/rep';
import { APIResult } from '../home/apiResult';
import { CreateAccountService } from '../account/create-account.service';
import { ICustomerInfoResponse } from '../account/customerinforesponse';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from '../admin/admin.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'environments/environment';
import { ILatestOnlineOrder } from '../onlineorder/latestonlineorder';
import { ApiCacheService } from '../core/api-cache.service';
import { SessionService } from '../session/session.service';
@Component({
  standalone: false,
  templateUrl: './login.component.html',
})
export class LoginComponent implements AfterViewInit, OnInit {
  @ViewChildren('input') vc: any;

  public pageTitle: string = 'Login';
  public loginInfo: any;
  public repId1: any;
  public apiRes!: APIResult;
  rep!: IRep;
  public ooInfo: ILatestOnlineOrder;
  public checkResult!: boolean;
  public cartItems!: ICartItems[];
  public allCustInfo: ICustomerInfoResponse;
  public caption: string;
  public transErrMsg: string;
  public translatedText: string = '';
  @Input() public count: number = 0;
  @Output() countChange: EventEmitter<number> = new EventEmitter<number>();
  public options = {
    position: ['bottom', 'right'],
    timeOut: 6000,
    lastOnBottom: true,
    preventDuplicates: false,
    preventLastDuplicates: false,
  };

  accounts!: IAccount[];
  errorMessage: string = '';
  constructor(
    private _loginService: LoginService,
    public fb: FormBuilder,
    private router: Router,
    private zone: NgZone,
    private app: AppComponent,
    public onlineorder: OnlineOrderService,
    @Inject(ElementRef) private element: ElementRef,
    private toaster: ToastrService,
    private orderService: OrderService,
    private createAccountService: CreateAccountService,
    public translate: TranslateService,
    public admin: AdminService,
    public spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private cache: ApiCacheService,
     private sessionService: SessionService
  ) {}
  public loginForm = this.fb.group({
    custEmail: ['', Validators.required],
    custPass: ['', Validators.required],
  });
  repId(): any {
    var currentId = localStorage.getItem('repId');
    return currentId;
  }
  getLocale(): any {
    var currentLocale = localStorage.getItem('locale');
    return currentLocale;
  }

  showError(errorMessage: string, subject: string, staticErrorMsg: boolean) {
    this.spinner.hide();
    //use this for dynamic error messages
    if (staticErrorMsg === false) {
      let locale = this.getLocale();
      if (locale !== 'en') {
        //were gonna do it nested, couldn't do it as a standalone method.
        let model = {
          q: [errorMessage],
          target: locale,
        };

        this.admin.googleTranslate(model).subscribe(
          (response: any) => {
            let res = response.data.translations[0].translatedText as string;
            this.translatedText = response.data.translations[0]
              .translatedText as string;
            this.transErrMsg = this.translatedText;
            localStorage.setItem('translatedText', res);
          },
          (error) => console.log(error),
          () => {
            this.translate.get(subject).subscribe(
              (res: string) => {
                this.caption = res;
                console.log(res);
              },
              (error) => console.log(error),
              () => {
                //once the caption is translated, fire off the toaster popup
                this.toaster.error(this.transErrMsg, this.caption, {
                  timeOut: 3000,
                });
                localStorage.removeItem('translatedText');
              },
            );
          },
        );
      } else {
        this.translate.get(subject).subscribe(
          (res: string) => {
            this.caption = res;
            console.log(res);
          },
          (error) => console.log(error),
          () => {
            this.transErrMsg = errorMessage;

            //once the caption is translated, fire off the toaster popup
            this.toaster.error(this.transErrMsg, this.caption, {
              timeOut: 3000,
            });
            localStorage.removeItem('translatedText');
          },
        );
      }
    } else {
      // translate the error message - not dynamic
      this.translate.get(errorMessage).subscribe((res: string) => {
        this.transErrMsg = res;
        console.log(res);
      });

      // translate the caption
      this.translate.get(subject).subscribe((res: string) => {
        this.caption = res;
        console.log(res);
      });
      //show the toaster popup
      this.toaster.error(this.transErrMsg, this.caption, {
        timeOut: 3000,
      });
    }
  }

  reset(): any {
    this._loginService
      .sendResetEmail(this.loginForm.controls['custEmail'].value)
      .subscribe(
        (res) => {
          this.apiRes = res;
        },
        (error) =>
          this.showError(
            'login.toastPopup.errors.resetErrorMsg',
            'login.toastPopup.errors.titles.resetErrTitle',
            true,
          ),
        () => {
          this._loginService
            .getCustomerDID(this.loginForm.controls.custEmail.value)
            .subscribe(
              (rep: IRep) => (this.rep = rep),
              (error: any) =>
                this.showError(
                  'login.toastPopup.errors.resetErrorMsg',
                  'login.toastPopup.errors.titles.resetErrTitle',
                  true,
                ),
              () => {
                this.showSuccess(
                  'login.toastPopup.success.resetMsg',
                  'login.toastPopup.success.titles.reset',
                  true,
                );
              },
            );

          //when successful do this stuff

          // setTimeout((router: Router) => {
          //     this._router.navigateByUrl('validate/from/' + this.repId());
          // }, 2000);
        },
      );
  }

  showSuccess(message: string, subject: string, staticMsg: boolean): void {
    // translate the error message - not dynamic
    this.translate.get(message).subscribe((res: string) => {
      this.transErrMsg = res;
      console.log(res);
    });

    // translate the caption
    this.translate.get(subject).subscribe((res: string) => {
      this.caption = res;
      console.log(res);
    });
    //show the toaster popup
    this.toaster.success(this.transErrMsg, this.caption, {
      timeOut: 3000,
    });
  }

  async login2(): Promise<void> {
    //const returnUrlRaw = this.route.snapshot.queryParamMap.get('returnUrl');
    //const returnUrl =
      //returnUrlRaw && returnUrlRaw.startsWith('/cart') ? returnUrlRaw : null;
    this.cache.clear();
    await this.sessionService.startSession();;
    this.spinner.show();
    this._loginService
      .someLogin(
        this.loginForm.controls.custEmail.value,
        this.loginForm.controls.custPass.value,
      )
      .subscribe(
        (thing) => (this.loginInfo = thing),
        (error) =>
          this.showError(
            'login.toastPopup.errors.loginFailed',
            'login.toastPopup.errors.titles.loginFailTitle',
            true,
          ),
        () => {
          this._loginService.getLbriWebApiToken().subscribe(
            (thing) => (this.loginInfo = thing),
            (error) => console.log(error),
            () => {
              this._loginService.getCustomerInfo().subscribe(
                (thing) => (this.loginInfo = thing),
                (error) => console.log(error),
                () => {
                  this.app.loggedIn = true;
                  if (this._loginService.loggedIn()) {
                    //this._loginService.getCustName().subscribe((thing: any) => this.loginInfo = thing,
                    //(error: string) => console.log(error), () => {
                    this.onlineorder.latestOnlineOrder(true).subscribe(
                      (thing2: ILatestOnlineOrder) => (this.ooInfo = thing2),
                      (error: string) => (this.errorMessage = error),
                      () => {
                        this.orderService.clearOrder().subscribe(
                          (thing3: IAccount[]) => (this.accounts = thing3),
                          (error: string) => (this.errorMessage = error),
                          () => {
                            //change market type here.
                            this.onlineorder.changeMarketType().subscribe({
                              next: (v) => '',
                              error: (e) => console.error(e),
                              complete: () => {
                                var myAuth = JSON.parse(
                                  localStorage.getItem('authorizationData'),
                                );
                                this.createAccountService
                                  .getCustomerInfo(myAuth.userName)
                                  .subscribe({
                                    next: (custRes) => {
                                      this.allCustInfo = custRes;
                                      // set this to be used later.
                                      localStorage.setItem(
                                        'allCustInfo',
                                        JSON.stringify(this.allCustInfo),
                                      );
                                      localStorage.setItem(
                                        'shippingData',
                                        JSON.stringify({
                                          first: this.allCustInfo.FirstName,
                                          last: this.allCustInfo.LastName,
                                          street1: this.allCustInfo.ShipStreet1,
                                          street2: this.allCustInfo.ShipStreet2,
                                          city: this.allCustInfo.ShipCity,
                                          state: this.allCustInfo.ShipState,
                                          zip: this.allCustInfo.ShipPostalCode,
                                          county: this.allCustInfo.ShipCounty,
                                          country: 'USA',
                                          email: this.allCustInfo.Email,
                                          phone: this.allCustInfo.Phone1,
                                        }),
                                      );
                                      let custName = (
                                        custRes.FirstName +
                                        ' ' +
                                        custRes.LastName
                                      )
                                        .toString()
                                        .replace('"', '');
                                      localStorage.setItem(
                                        'custName',
                                        custName,
                                      );
                                      this.app.myCustName = custName;
                                      if (
                                        this.allCustInfo.PreferredCulture === 1
                                      )
                                        this.app.useLanguage('en');
                                      else this.app.useLanguage('es');
                                    },
                                    complete: () => {
                                      ///////// THIS STATEMENT MAKES SURE THE MERGE TAKES PLACE. ALSO CALCULATES TAXES.
                                      // log rocket
                                      if (environment.logrocketEnabled) {
                                        let orderInfo = JSON.parse(
                                          localStorage.getItem('orderId'),
                                        );
                                        this._loginService.setCurrentUser(
                                          this.allCustInfo,
                                          orderInfo.ID,
                                        );
                                      }

                                      if (
                                        this.orderService.getCart().length > 0
                                      ) {
                                        this.cartItems =
                                          this.orderService.getCart();
                                        var prodC = 0;
                                        for (
                                          var i = 0;
                                          i <
                                          this.orderService.getCart().length;
                                          i++
                                        ) {
                                          // see if any of the items have been ordered, if not add them to online order.
                                          this.orderService
                                            .checkIfOrdered2(
                                              this.cartItems[i].ProductId,
                                            )
                                            .subscribe(
                                              null,
                                              () => {
                                                if (prodC <= i) {
                                                  //console.log("good");
                                                  this.orderService
                                                    .mergeToOrder(prodC)
                                                    .subscribe(
                                                      null,
                                                      (error: string) =>
                                                        (this.errorMessage =
                                                          error),
                                                      () => {
                                                        //console.log('merging to order, no bad item.');
                                                        this.onlineorder
                                                          .calculateTax()
                                                          .subscribe(
                                                            (thing2) => thing2,
                                                            (error) =>
                                                              console.log(
                                                                error,
                                                              ),
                                                            () => {
                                                              this.orderService
                                                                .updateShipMethodPlusTotals2()
                                                                .subscribe({
                                                                  next(value) {
                                                                    localStorage.setItem(
                                                                      'orderInfo',
                                                                      JSON.stringify(
                                                                        value,
                                                                      ),
                                                                    );
                                                                  },
                                                                  complete:
                                                                    () => {
                                                                      //make sure that we store the cart items in its local storage and prod ct.
                                                                     // console.log('do something');
                                                                       //console.log(this.onlineorder.getCart());
                                                                      // let item1: ICartItems =
                                                                      //   {
                                                                      //     ProductId:
                                                                      //       this
                                                                      //         .ooInfo
                                                                      //         .Items[0]
                                                                      //         .ProductId,
                                                                      //     DisplayName:
                                                                      //       this
                                                                      //         .ooInfo
                                                                      //         .Items[0]
                                                                      //         .DisplayName,
                                                                      //     ImageUrl:
                                                                      //       this
                                                                      //         .ooInfo
                                                                      //         .Items[0]
                                                                      //         .ImageUrl,
                                                                      //     Price:
                                                                      //       this
                                                                      //         .ooInfo
                                                                      //         .Items[0]
                                                                      //         .Price,
                                                                      //     Quantity: 1,
                                                                      //   };

                                                                      // if (
                                                                      //   this.onlineorder.addItem(
                                                                      //     item1,
                                                                      //   ) ==
                                                                      //   true
                                                                      // ) {
                                                                      //   var newCount =
                                                                      //     localStorage.getItem(
                                                                      //       'prodCount',
                                                                      //     );

                                                                      //   if (
                                                                      //     newCount ==
                                                                      //       null ||
                                                                      //     newCount ==
                                                                      //       '0'
                                                                      //   ) {
                                                                      //     this.count = 0;
                                                                      //   }
                                                                      //   this
                                                                      //     .count++;
                                                                      //   this.countChange.emit(
                                                                      //     this
                                                                      //       .count,
                                                                      //   );

                                                                      //   //localStorage.removeItem('authorizationData');
                                                                      //   this.app.myProdCount =
                                                                      //     this.count;
                                                                      //   localStorage.setItem(
                                                                      //     'cartItems',
                                                                      //     JSON.stringify(
                                                                      //       this.onlineorder.getCart(),
                                                                      //     ),
                                                                      //   );

                                                                      //   localStorage.setItem(
                                                                      //     'prodCount',
                                                                      //     this.app.myProdCount.toString(),
                                                                      //   );
                                                                      // }
                                                                    },
                                                                });
                                                            },
                                                          );
                                                      },
                                                    );
                                                  prodC++;
                                                }
                                                ///////// THIS STATEMENT REMOVES THE BAD ITEMS.
                                                else if (
                                                  prodC <=
                                                  this.orderService.cart.length
                                                ) {
                                                  // need to kick out the bad item
                                                  console.log(prodC);
                                                  var badItem: ICartItems = {
                                                    ProductId:
                                                      this.cartItems[prodC]
                                                        .ProductId,
                                                    DisplayName:
                                                      this.cartItems[prodC]
                                                        .DisplayName,
                                                    ImageUrl:
                                                      this.cartItems[prodC]
                                                        .ImageUrl,
                                                    Price:
                                                      this.cartItems[prodC]
                                                        .Price,
                                                    Quantity:
                                                      this.cartItems[prodC]
                                                        .Quantity,
                                                  };
                                                  //this.cartItems = this.orderService.deleteItem(badItem);
                                                  this.orderService.cart =
                                                    this.orderService.deleteItem(
                                                      badItem,
                                                    );
                                                  //console.log(JSON.stringify(this.orderService.cart));
                                                  localStorage.removeItem(
                                                    'cartItems',
                                                  );
                                                  localStorage.setItem(
                                                    'cartItems',
                                                    JSON.stringify(
                                                      this.orderService.getCart(),
                                                    ),
                                                  );
                                                  var newCount =
                                                    localStorage.getItem(
                                                      'prodCount',
                                                    );

                                                  var count =
                                                    Number(newCount) - 1;
                                                  localStorage.removeItem(
                                                    'prodCount',
                                                  );
                                                  localStorage.setItem(
                                                    'prodCount',
                                                    count.toString(),
                                                  );

                                                  this.cartItems =
                                                    this.orderService.getCart();
                                                  //this.cartItems = this.orderService.getCart();
                                                  this.onlineorder
                                                    .calculateTax()
                                                    .subscribe(
                                                      (thing2) => thing2,
                                                      (error) =>
                                                        console.log(error),
                                                      () => {
                                                        this.orderService
                                                          .updateShipMethodPlusTotals2()
                                                          .subscribe({
                                                            next(value) {
                                                              localStorage.setItem(
                                                                'orderInfo',
                                                                JSON.stringify(
                                                                  value,
                                                                ),
                                                              );
                                                            },
                                                          });
                                                      },
                                                    );
                                                  this.showError(
                                                    'login.toastPopup.errors.mergeError',
                                                    'login.toastPopup.errors.titles.mergeErrorTitle',
                                                    true,
                                                  );
                                                  //prodC++;
                                                  //i--;
                                                }

                                                //console.log(JSON.stringify(this.cartItems) + " Product Count Index: " + prodC);
                                                //}
                                              },
                                              () => {
                                                // this part is if there is a bad item.

                                                console.log(
                                                  prodC + ' - is a bad item',
                                                );
                                                var badItem: ICartItems = {
                                                  ProductId:
                                                    this.cartItems[prodC]
                                                      .ProductId,
                                                  DisplayName:
                                                    this.cartItems[prodC]
                                                      .DisplayName,
                                                  ImageUrl:
                                                    this.cartItems[prodC]
                                                      .ImageUrl,
                                                  Price:
                                                    this.cartItems[prodC].Price,
                                                  Quantity:
                                                    this.cartItems[prodC]
                                                      .Quantity,
                                                };
                                                //this.cartItems = this.orderService.deleteItem(badItem);
                                                this.orderService.cart =
                                                  this.orderService.deleteItem(
                                                    badItem,
                                                  );
                                                console.log(
                                                  'removed the bad item. no longer valid item',
                                                );
                                                //console.log(JSON.stringify(this.orderService.cart));
                                                localStorage.removeItem(
                                                  'cartItems',
                                                );
                                                localStorage.setItem(
                                                  'cartItems',
                                                  JSON.stringify(
                                                    this.orderService.getCart(),
                                                  ),
                                                );
                                                var newCount =
                                                  localStorage.getItem(
                                                    'prodCount',
                                                  );

                                                var count =
                                                  Number(newCount) - 1;
                                                localStorage.removeItem(
                                                  'prodCount',
                                                );
                                                localStorage.setItem(
                                                  'prodCount',
                                                  count.toString(),
                                                );

                                                this.cartItems =
                                                  this.orderService.getCart();
                                                //this.cartItems = this.orderService.getCart();
                                                this.onlineorder
                                                  .calculateTax()
                                                  .subscribe(
                                                    (thing2) => thing2,
                                                    (error) =>
                                                      console.log(error),
                                                    () => {
                                                      this.orderService
                                                        .updateShipMethodPlusTotals2()
                                                        .subscribe({
                                                          next(value) {
                                                            localStorage.setItem(
                                                              'orderInfo',
                                                              JSON.stringify(
                                                                value,
                                                              ),
                                                            );
                                                          },
                                                        });

                                                      this.showError(
                                                        'login.toastPopup.errors.mergeError',
                                                        'login.toastPopup.errors.titles.mergeErrorTitle',
                                                        true,
                                                      );
                                                    },
                                                  );
                                              },
                                            );
                                        }
                                      }

                                      //this.onlineorder.calculateTax().subscribe(thing2 => thing2, error => console.log(error), () => {
                                      this.spinner.hide();
                                      this.zone.run(() => {
                                        setTimeout(() => {
                                        //   this.app.myRepID = this.repId();

                                        //   const fallback =
                                        //     'shop/from/' + this.repId();
                                        //   const dest = returnUrl ?? fallback;

                                        //   this.router.navigateByUrl(dest);
                                        // }, 1000);
                                        this.app.myRepID = this.repId();
                                          this.router.navigateByUrl(
                                            'shop/from/' + this.repId()
                                          );
                                        }, 1000);
                                      });
                                      //});
                                    },
                                    error: (err) => {
                                      this.spinner.hide();
                                      console.log(err);
                                    },
                                  });
                              },
                            });
                          },
                        );
                      },
                    );

                    //});
                  }
                },
              );
            },
          );
        },
      );
    //this.spinner.hide();
  }
  ngAfterViewInit() {
    this.element.nativeElement.focus();
    // this.vc.element.nativeElement.focus();
  }

  ngOnInit(): void {
    //this.vc.first.nativeElement.focus();
    //this.loginForm.controls.custEmail.f
  }
}
